// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10xC3","col":"styles_col__2Z-P1"};